import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';

import { IonicVue } from '@ionic/vue';

import * as Sentry from "@sentry/vue";

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

const app = createApp(App)
	.use(IonicVue)
	.use(store)
	.use(router);

Sentry.init({
	app,
	dsn: "https://d77c2a363c0d2cfc3ea2b003612d0d10@o4511025763450880.ingest.de.sentry.io/4511025765679184",
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true
});

router.isReady().then(() => {
	app.mount('#app');
});